"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ratingTextStyles = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_rating_1 = require("@hotelplan/components.common.rating");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const ratingTextStyles = ({ theme }) => theme.destinationAttributes.ratingTextStyles;
exports.ratingTextStyles = ratingTextStyles;
const DestinationBaseRating = (0, styled_components_1.default)(components_common_rating_1.Rating)({
    display: 'flex',
    alignItems: 'center',
}, ({ subRating, theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    '.rating': subRating
        ? theme.destinationAttributes.destinationRatingSubStyles
        : theme.destinationAttributes.destinationRatingStyles,
    '.remainRating': subRating
        ? Object.assign(Object.assign({}, theme.destinationAttributes.destinationRatingSubStyles), theme.destinationAttributes.destinationRemainRatingSubStyles) : Object.assign(Object.assign({}, theme.destinationAttributes.destinationRatingStyles), theme.destinationAttributes.destinationRemainRatingStyles),
}));
const DestinationRating = ({ rating, subRating, }) => {
    const currentRating = (rating || 0) / 10;
    return (react_1.default.createElement(DestinationBaseRating, { maxRating: 5, rating: currentRating, subRating: subRating }));
};
exports.default = DestinationRating;
//# sourceMappingURL=DestinationRating.js.map